/** Mirror of BetBond mobile betHouseTreasuryPartners — accepted house partners. */

function toRefIdString(ref) {
  if (ref == null || ref === "") return "";
  if (typeof ref === "object" && ref !== null && ref._id != null) {
    return String(ref._id);
  }
  return String(ref);
}

export function resolveBetHouseOwnerId(bet) {
  const fromOwner = toRefIdString(bet?.owner);
  if (fromOwner) return fromOwner;
  const ownerRow = (bet?.users || []).find((u) => String(u.role || "") === "owner");
  return toRefIdString(ownerRow?.userId);
}

export function getAcceptedCapitalPartners(bet) {
  const users = Array.isArray(bet?.users) ? bet.users : [];
  return users.filter(
    (u) =>
      (u.role === "owner" || u.role === "admin") &&
      String(u.status || "accepted") === "accepted"
  );
}

export function isPartneredHouse(bet) {
  return getAcceptedCapitalPartners(bet).length >= 2;
}

export function canUserRunConsoleTreasuryMove(bet, userId) {
  if (!bet || !userId) return false;
  const uid = toRefIdString(userId);
  const ownerId = resolveBetHouseOwnerId(bet);
  if (!ownerId || uid !== ownerId) return false;

  const entry = (bet.users || []).find((u) => toRefIdString(u.userId) === uid);
  if (!entry) return false;
  if (!["owner", "admin"].includes(String(entry.role || ""))) return false;
  if (String(entry.status || "accepted") !== "accepted") return false;

  return true;
}

export function hasPendingPartnerRequest(partnerData) {
  if (!partnerData) return false;
  const now = Date.now();
  if (
    partnerData.pendingRequest &&
    new Date(partnerData.pendingRequest.expiresAt).getTime() > now
  ) {
    return true;
  }
  return (partnerData.requests || []).some(
    (request) =>
      request.status === "pending" &&
      new Date(request.expiresAt).getTime() > now
  );
}

export function isBetHousePartnershipReadyForConsole(bet) {
  if (!bet) return false;
  if (String(bet.status || "") === "closed") return false;
  if (String(bet.approvalStatus || "") === "rejected") return false;
  const users = Array.isArray(bet.users) ? bet.users : [];
  const coOwnerRows = users.filter((u) =>
    ["owner", "admin"].includes(String(u.role || ""))
  );
  if (coOwnerRows.length === 0) return false;
  const allAccepted = coOwnerRows.every(
    (u) => String(u.status || "") === "accepted"
  );
  if (!allAccepted) return false;
  return String(bet.approvalStatus || "") === "accepted";
}

export function maxEqualShareCash(total, count) {
  const n = Math.max(1, Math.floor(Number(count)) || 1);
  const cents = Math.round(Number(total) * 100);
  if (!Number.isFinite(cents) || cents <= 0) return 0;
  const base = Math.floor(cents / n);
  const remainder = cents - base * n;
  return (base + (remainder > 0 ? 1 : 0)) / 100;
}

export function countBetHousesActiveInactive(bets) {
  if (!Array.isArray(bets) || !bets.length) return { active: 0, inactive: 0 };
  let active = 0;
  for (const b of bets) {
    if (String(b?.status || "").toLowerCase() === "active") active += 1;
  }
  return { active, inactive: bets.length - active };
}
